import Vue from 'vue'
import * as en from './En'

Vue.prototype.$lang = en
Vue.prototype.$whoops = () => Vue.$toast.warning(en.common.whoops)
